export function TextSaveToFile(filename: string, text: string) {
  var blob = new Blob([text], { type: "text/plain" });
  BlobSaveToFile(blob, filename)
}

export function BlobSaveToFile(blob: Blob, fileName: string) {
  var url = window.URL.createObjectURL(blob);
  UrlSaveToFile(url, fileName)
}

export function UrlSaveToFile(url: string, fileName: string) {
  var fileLink = document.createElement('a');
  fileLink.href = url;
  fileLink.download = fileName;
  document.body.appendChild(fileLink);
  fileLink.click();
  fileLink.remove();
}

export async function UrlSaveToFileAsync(url: string, fileName?: string) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    if (!fileName) {
      const disposition = response.headers.get("Content-Disposition");
      if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?($|;)/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }
    }

    fileName = fileName || "download";

    const fileLink = document.createElement("a");
    fileLink.href = URL.createObjectURL(blob);
    fileLink.download = fileName;
    fileLink.click();
    fileLink.remove();
  } catch (error) {
    console.error(error);
  }
}